import LoadingButton from "@mui/lab/LoadingButton";
import { Button, Container, Stack, TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useCallback, useEffect, useRef, useState } from "react";
import Clipboard from "react-clipboard.js";
import { connect } from "react-redux";

import { refreshAccessToken } from "../../../commons";
import Page from "../Page";

const Profile = ({ member }) => {
  const [isRefreshingAccessToken, toggleRefreshingAccessToken] =
    useState(false);
  const [accessToken, setAccessToken] = useState();

  const timer = useRef();

  const refresh = useCallback(async () => {
    toggleRefreshingAccessToken(true);

    setAccessToken(await refreshAccessToken());

    toggleRefreshingAccessToken(false);

    timer.current = setTimeout(() => {
      setAccessToken(null);
    }, 1000 * 60);
  }, []);

  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  return (
    <>
      <Page
        title="Profile"
        //  display="flex" height="100%"
      >
        <Container maxWidth="md">
          <Stack spacing={5}>
            <TextField
              variant="standard"
              label="메일 주소"
              value={member.email}
              InputProps={{ readOnly: true }}
            />
            <TextField
              variant="standard"
              label="가입시 기재 실명"
              value={member.name || "(가입 전)"}
              InputProps={{ readOnly: true }}
            />
            <TextField
              variant="standard"
              label="표시 이름"
              value={member.displayName}
              InputProps={{ readOnly: true }}
            />

            <Box>
              <Typography variant="h6">(dev) Access token</Typography>

              <LoadingButton
                variant="contained"
                color="primary"
                loading={!!accessToken || isRefreshingAccessToken}
                loadingIndicator={
                  isRefreshingAccessToken ? "Loading" : "Refreshed!"
                }
                onClick={refresh}
              >
                Refresh
              </LoadingButton>

              <Clipboard
                component={"div"}
                data-clipboard-text={accessToken}
                onSuccess={() => {
                  alert("Copied!");
                }}
                style={{ display: "inline-block" }}
              >
                <Button variant="contained" disabled={!accessToken}>
                  Get
                </Button>
              </Clipboard>
            </Box>
          </Stack>
        </Container>
      </Page>
    </>
  );
};

const mapState = ({ auth: { member } }) => ({ member });
export default connect(mapState)(Profile);
